import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import defaultImg from './../../../images/veezzo-logo.jpg';
import DrawingPolygonMap from '../../Maps';
import { var_api , image_api } from '../../../constant';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';
import swal from "sweetalert";

const CityMaster = () => {
  const tableHeaders = ["#", "Image", "District", "City", "Description", "Radius", "Status", "Action"];

  const [cityData, setCityData] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    city_name: '',
    district_id: '',
    description: '',
    image: '',
    geo_boundary: '',
    center_lat: '',
    center_lang: '',
    total_radius: '',
    active_status: 1, // ✅ numeric by default
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const loadInitialData = async () => {
      try {
        setInitialLoading(true);
        await Promise.all([fetchCityData(), fetchDistricts()]);
      } catch (error) {
        console.error("Failed to load initial data:", error);
      } finally {
        setInitialLoading(false);
      }
    };
    

    loadInitialData();
  }, []);

  const fetchCityData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_city_master/get`);
      setCityData(res.data || []);
    } catch (err) {
      console.error("Failed to fetch city data", err);
    }
  };

  const fetchDistricts = async () => {
    try {
      const res = await axios.get(`${var_api}sa_district_master/get`);
      setDistrictList(res.data || []);
    } catch (err) {
      console.error("Failed to fetch districts", err);
    }
  };

 const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({ ...prev, [name]: value }));
  setErrors(prev => ({ ...prev, [name]: '' })); // Clear error for that field
};

  const handleAddClick = () => {
     setErrors({});  
    setFormData({
      id: null,
      city_name: '',
      district_id: '',
      description: '',
      image: '',
      geo_boundary: '',
      center_lat: '',
      center_lang: '',
      total_radius: '',
      active_status: 1 // ✅ reset to numeric
    });
    setFile(null);
    setIsEditMode(false);
    setShowModal(true);
  };

  const handleEditClick = (item) => {
    setFormData({ ...item, active_status: Number(item.active_status) }); // ✅ Ensure numeric
    setFile(null);
    setIsEditMode(true);
    setShowModal(true);
     setErrors({});

  };

  const handlePolygonComplete = (geoString) => {
    setFormData(prev => ({ ...prev, geo_boundary: geoString }));
  };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // if (!formData.geo_boundary || formData.geo_boundary.trim() === '') {
//     //   swal("Please draw a geo boundary on the map.");
//     //   return;
//     // }
//      const newErrors = {};
//   if (!formData.district_id) newErrors.district_id = "District is required";
//   if (!formData.city_name.trim()) newErrors.city_name = "City  is required";
//   if (!formData.center_lat) newErrors.center_lat = "Latitude is required";
//   if (!formData.center_lang) newErrors.center_lang = "Longitude is required";
//   if (!formData.total_radius) newErrors.total_radius = "Radius is required";
//   if (!formData.geo_boundary) newErrors.geo_boundary = "Please draw a geo boundary";

//   setErrors(newErrors);

//   if (Object.keys(newErrors).length > 0) {
//     toast.warning("Please fill in all required fields");
//     return;
//   }

//     setLoading(true);

//     try {
//        setLoading(true);
//       const token = localStorage.getItem("token");
//       const mobile = localStorage.getItem("mobile");

//       const form = new FormData();
//       form.append('mobile', mobile);
//       form.append('district_id', formData.district_id);
//       form.append('city_name', formData.city_name);
//       form.append('description', formData.description);
//       form.append('geo_boundary', formData.geo_boundary);
//       form.append('center_lat', formData.center_lat);
//       form.append('center_lang', formData.center_lang);
//       form.append('total_radius', formData.total_radius);
//       form.append('active_status', formData.active_status); // ✅ numeric
//         if (file) {
//       form.append('image', file);
//     } else if (isEditMode && formData.image === '') {
//       form.append('image', ''); // ✅ force backend to clear the image
// }

//       const config = {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//           Authorization: `${token}`,
//         },
//       };

//       if (isEditMode && formData.id) {
//         await axios.put(`${var_api}sa_city_master/update/${formData.id}`, form, config);
//       } else {
//         await axios.post(`${var_api}sa_city_master/post`, form, config);
//       }

//       toast.success(
//         isEditMode ? "City updated successfully!" : "City created successfully!",
//         {
//           position: "top-right",
//           autoClose: 5000,
//         }
//       );

//       setShowModal(false);
//       setFormData({
//         id: null,
//         city_name: '',
//         district_id: '',
//         description: '',
//         image: '',
//         geo_boundary: '',
//         center_lat: '',
//         center_lang: '',
//         total_radius: '',
//         active_status: 1
//       });
//       setFile(null);
//       fetchCityData();
//     } catch (err) {
//       console.error("Error saving city:", err);
//       toast.error("Error saving city. Please try again.", {
//         position: "top-right",
//         autoClose: 5000,
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

const handleSubmit = async (e) => {
  e.preventDefault();

  const newErrors = {};
  if (!formData.district_id) newErrors.district_id = "District is required";
  if (!formData.city_name.trim()) newErrors.city_name = "City is required";
  if (!formData.center_lat) newErrors.center_lat = "Latitude is required";
  if (!formData.center_lang) newErrors.center_lang = "Longitude is required";
  if (!formData.total_radius) newErrors.total_radius = "Radius is required";
  if (!formData.geo_boundary) newErrors.geo_boundary = "Please draw a geo boundary";

  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
    toast.warning("Please fill in all required fields");
    return;
  }

  setLoading(true);

  try {
    const token = localStorage.getItem("token");
    const mobile = localStorage.getItem("mobile");

    const form = new FormData();
    form.append('mobile', mobile);
    form.append('district_id', formData.district_id);
    form.append('city_name', formData.city_name);
    form.append('description', formData.description);
    form.append('geo_boundary', formData.geo_boundary);
    form.append('center_lat', formData.center_lat);
    form.append('center_lang', formData.center_lang);
    form.append('total_radius', formData.total_radius);
    form.append('active_status', formData.active_status);

    if (file) {
      form.append('image', file);
    } else if (isEditMode && formData.image === '') {
      form.append('image', '');
    }

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `${token}`,
      },
    };

    let response;
    if (isEditMode && formData.id) {
      response = await axios.put(`${var_api}sa_city_master/update/${formData.id}`, form, config);
    } else {
      response = await axios.post(`${var_api}sa_city_master/post`, form, config);
    }

    toast.success(response.data?.message || "Operation successful!", {
      position: "top-right",
      autoClose: 5000,
    });

    setShowModal(false);
    setFormData({
      id: null,
      city_name: '',
      district_id: '',
      description: '',
      image: '',
      geo_boundary: '',
      center_lat: '',
      center_lang: '',
      total_radius: '',
      active_status: 1
    });
    setFile(null);
    fetchCityData();

  } catch (err) {
    console.error("Error saving city:", err);
    toast.error(err.response?.data?.message || "Error saving city. Please try again.", {
      position: "top-right",
      autoClose: 5000,
    });
  } finally {
    setLoading(false);
  }
};

  const handleReset = () => {
    setFormData({
      id: null,
      city_name: '',
      district_id: '',
      description: '',
      image: '',
      geo_boundary: '',
      center_lat: '',
      center_lang: '',
      total_radius: '',
      active_status: 1
    });
    setFile(null);
  };

  const filteredData = cityData.filter(item =>
    Object.values(item).some(val => String(val).toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <Card>
        <Card.Body>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search city..."
                  value={searchQuery}
                  onChange={e => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                <Button variant="secondary" onClick={handleAddClick}>Add</Button>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      {tableHeaders.map((header, idx) => (
                        <th key={idx}>{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan={tableHeaders.length} className="text-center text-muted py-4">
                          No data found
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                          <td>
                            <img
                              src={item.image ? `${image_api}${item.image.replace(/^test\//, '')}` : defaultImg}
                              alt="city"
                              width="40"
                              height="40"
                              className="rounded"
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                window.open(`${image_api}${item.image.replace(/^test\//, '')}`, '_blank');
                              }}
                            />
                          </td>
                          <td>{districtList.find(d => d.id.toString() === item.district_id?.toString())?.district_name || "-"}</td>
                          <td>{item.city_name}</td>
                          <td>{item.description}</td>
                          <td>{item.total_radius}</td>
                          <td>
                            <span className={`badge ${item.active_status === 1 ? 'bg-success' : 'bg-danger'}`}>
                              {item.active_status === 1 ? 'Active' : 'Inactive'}
                            </span>
                          </td>
                          <td className="text-center">
                            <Link
                              to="#"
                              className="btn shadow btn-xs sharp me-1"
                              style={{ backgroundColor: "#007bff", color: "white" }}
                              onClick={() => handleEditClick(item)}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </Link>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}

           <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
    <Modal.Header closeButton>
      <Modal.Title>{isEditMode ? "Edit City" : "Add City"}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6">
            {/* District */}
            <Form.Group className="mb-2">
              <Form.Label>District <span className="text-danger">*</span></Form.Label>
              <Select
                name="district_id"
                value={districtList.find(d => d.id === formData.district_id) || null}
                onChange={(selectedOption) => {
                  setFormData({ ...formData, district_id: selectedOption?.id || '' });
                  setErrors(prev => ({ ...prev, district_id: '' }));
                }}
                options={districtList}
                getOptionLabel={(e) => e.district_name}
                getOptionValue={(e) => e.id}
                placeholder="Select District"
                isClearable
              />
              {errors.district_id && <div className="text-danger small mt-1">{errors.district_id}</div>}
            </Form.Group>

            {/* City name, Description, Lat/Lng, Radius */}
            {["city_name", "description", "center_lat", "center_lang", "total_radius"].map((field, i) => (
              <Form.Group className="mb-2" key={i}>
                <Form.Label>{field.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())} {['city_name', 'center_lat', 'center_lang', 'total_radius'].includes(field) && <span className="text-danger">*</span>}</Form.Label>
                <Form.Control
                  type="text"
                  name={field}
                  value={formData[field]}
                  onChange={handleInputChange}
                  placeholder={`Enter ${field.replace(/_/g, ' ')}`}
                  isInvalid={!!errors[field]}
                />
                <Form.Control.Feedback type="invalid">{errors[field]}</Form.Control.Feedback>
              </Form.Group>
            ))}

            {/* Image */}
            <Form.Group className="mb-2">
              <Form.Label>Image</Form.Label>
              {isEditMode && formData.image && !file && (
                <div className="d-flex align-items-center gap-3 mb-2">
                  <img
                    src={`${image_api}${formData.image.replace(/^test\//, '')}`}
                    alt="Preview"
                    width="100"
                    className="rounded border"
                    style={{ objectFit: 'cover' }}
                  />
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => {
                      setFormData(prev => ({ ...prev, image: '' }));
                      setFile(null);
                    }}
                  >
                    Remove
                  </Button>
                </div>
              )}
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </Form.Group>

            {/* Status Switch */}
            {isEditMode && (
          <Form.Group className="mb-2 d-flex align-items-center gap-2">
          <Form.Label className="mb-0">
            {formData.active_status === 1 ? "Active" : "Inactive"}
          </Form.Label>
          <Form.Check
            type="switch"
            id="active-status-switch"
            checked={formData.active_status === 1}
            onChange={(e) =>
              setFormData({
                ...formData,
                active_status: e.target.checked ? 1 : 0,
              })
            }
            className={formData.active_status === 1 ? "custom-switch-green" : ""}
          />
        </Form.Group>
            )}
          </div>

            <div className="col-md-6">
              <Form.Group className="mb-2">
                <Form.Label>Geo Boundary (Draw on Map) <span className="text-danger">*</span></Form.Label>
                <div style={{ height: "600px", border: "1px solid #ccc", marginBottom: "10px" }}>
                    <DrawingPolygonMap
                  onPolygonComplete={(polygonString) => {
                    setFormData(prev => ({ ...prev, geo_boundary: polygonString }));
                    setErrors(prev => ({ ...prev, geo_boundary: '' }));
                  }}
                  initialPolygon={formData.geo_boundary}
                />
                </div>
                {errors.geo_boundary && <div className="text-danger small mt-1">{errors.geo_boundary}</div>}
              </Form.Group>

              {formData.geo_boundary && (
                <Form.Group className="mb-2">
                  <Form.Label>Polygon Data</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    readOnly
                    value={formData.geo_boundary}
                  />
                </Form.Group>
              )}
            </div>
        </div>

        <div className="d-flex justify-content-end gap-2">
      {!isEditMode ? (
        <>
          <Button variant="secondary" type="submit" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Creating...
              </>
            ) : (
              "Create"
            )}
          </Button>
          <Button
            variant="danger"
            type="reset"
            disabled={loading}
           onClick={handleReset}
          >
            Reset
          </Button>
        </>
      ) : (
        <>
          <Button variant="warning" type="submit" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Updating...
              </>
            ) : (
              "Update"
            )}
          </Button>
          <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>
            Cancel
          </Button>
        </>
      )}
    </div>
      </Form>
    </Modal.Body>
  </Modal>
  <style>{`
        .custom-switch-green .form-check-input:checked {
          background-color: #28a745 !important;
          border-color: #28a745 !important;
        }
        .custom-switch-red .form-check-input {
          background-color: #dc3545 !important;
          border-color: #dc3545 !important;
        }
      `}</style>
        </Card.Body>
      </Card>
      <ToastContainer />
    </>
  );
};

export default CityMaster;
